import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_GRUPPO } from '../../data.const';
import { setCurrentGruppoAction, setLoaders } from '../../data.action';

const retrieveGruppoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_GRUPPO),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_GRUPPO}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ gruppoLoader: true })),
        defer(() =>
          from(request({ path: `gruppo/${id}`, method: httpMethods.GET })).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_GRUPPO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentGruppoAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_GRUPPO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ gruppoLoader: false }))
      );
    })
  );

export default retrieveGruppoEpic;
